import { SHOW_TOAST, HIDE_TOAST } from "../actions"

const initialState = {
  visible: false,
  message: '',
  type: 'success',
  position: 'bottom-right',
}

export const toastReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TOAST:
      return {
        ...state,
        visible: true,
        message: action.payload.message,
        type: action.payload.type,
        position: action.payload.position || state.position,
      }

    case HIDE_TOAST:
      return {
        ...state,
        visible: false,
      }

    default:
      return state
  }
}
